// extracted by mini-css-extract-plugin
module.exports = {"Tooltip__Trigger":"styles_Tooltip__Trigger__1xHOl","Tooltip__Content":"styles_Tooltip__Content__1nXuR"};